export const TimelineModeOptions = {
	DAYS: 'DAYS',
	WEEKS: 'WEEKS',
	MONTHS: 'MONTHS',
	QUARTERS: 'QUARTERS',
} as const;
export type TimelineMode = keyof typeof TimelineModeOptions;

type Duration = {
	startDate: Date;
	endDate: Date;
};

export type TimelineDuration = Duration;

export type TimelineWindow = {
	before: Date;
	after: Date;
};

export type ColumnDuration = Duration;

export type DATE_RANGE = {
	fromDate: number;
	toDate: number;
};
